define.alias("shared/components/shared/carousel/indicators", "media/components/shared/carousel/indicators");